var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid__col--space"},[_c('div',{staticClass:"card"},[_c('Form',{attrs:{"form":_vm.form,"formData":_vm.formData,"formEntry":_vm.formEntry,"isOrganizer":_vm.isOrganizer},on:{"form-changed":_vm.onFormChanged}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }